(function() {
    'use strict';

    const hamburger = document.querySelector('.hamburger');
    const mobileMenu = document.getElementById('mobile-menu');
    const mobileMenuClose = document.querySelector('.mobile-menu-close');
    const body = document.body;

    // English comment: Track input modality so we only auto-close on keyboard navigation
    let usingKeyboard = false;

    document.addEventListener('keydown', function(e) {
        if (e.key === 'Tab') {
            usingKeyboard = true;
        }
    }, true);

    ['mousedown', 'pointerdown', 'touchstart'].forEach(function(evt) {
        document.addEventListener(evt, function() {
            usingKeyboard = false;
        }, true);
    });

    // English comment: The hamburger button and the overlay together form the "navigation"
    function isInsideNavigation(el) {
        if (!el) return false;
        return el === hamburger || mobileMenu.contains(el) || (hamburger && hamburger.contains(el));
    }

    if (hamburger && mobileMenu) {
        // Toggle menu open/close
        hamburger.addEventListener('click', function() {
            const isExpanded = this.getAttribute('aria-expanded') === 'true';
            this.setAttribute('aria-expanded', (!isExpanded).toString());

            if (!isExpanded) {
                mobileMenu.classList.add('is-open');
                body.style.overflow = 'hidden';
                const firstFocusable = mobileMenu.querySelector('button, a, input');
                if (firstFocusable) {
                    setTimeout(() => firstFocusable.focus(), 100);
                }
            } else {
                closeMobileMenu();
            }
        });

        // Close via X button
        if (mobileMenuClose) {
            mobileMenuClose.addEventListener('click', function() {
                closeMobileMenu();
                hamburger.focus();
            });
        }

        // ESC sluit menu
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape' && mobileMenu.classList.contains('is-open')) {
                closeMobileMenu();
                hamburger.focus();
            }
        });

        // English comment: Close the menu when keyboard focus leaves the navigation (a11y)
        document.addEventListener('focusin', function(e) {
            if (!usingKeyboard) return;
            if (!mobileMenu.classList.contains('is-open')) return;
            if (isInsideNavigation(e.target)) return;

            // Focus already moved outside: close the menu but keep the new focus position
            closeMobileMenu();
        });

        // English comment: Tabbing past the last item can move focus to <body> or the browser UI,
        // which does not trigger 'focusin'. Check the active element right after the Tab key.
        document.addEventListener('keyup', function(e) {
            if (e.key !== 'Tab') return;
            if (!mobileMenu.classList.contains('is-open')) return;

            const active = document.activeElement;
            if (!active || active === body || active === document.documentElement || !isInsideNavigation(active)) {
                closeMobileMenu();
            }
        });
    }

    function closeMobileMenu() {
        hamburger.setAttribute('aria-expanded', 'false');
        mobileMenu.classList.remove('is-open');
        body.style.overflow = '';

        // Close all open submenus as well
        document.querySelectorAll('.mobile-menu .submenu-toggle').forEach(btn => {
            btn.setAttribute('aria-expanded', 'false');
            btn.classList.remove('is-open');
            const sub = btn.parentElement.querySelector(':scope > .sub-menu');
            if (sub) {
                sub.classList.remove('is-open');
                sub.setAttribute('aria-hidden', 'true');
            }
        });
    }

    // Build/ensure submenu toggles for mobile
    const itemsWithChildren = document.querySelectorAll('.mobile-menu .menu-item-has-children');

    itemsWithChildren.forEach(function(item) {
        const link = item.querySelector(':scope > a');
        const submenu = item.querySelector(':scope > .sub-menu');
        if (!link || !submenu) return;

        // Hide submenu by default (via classes; CSS animates)
        submenu.classList.remove('is-open');
        submenu.setAttribute('aria-hidden', 'true');

        // Check if toggle already exists (avoid duplicates when re-init)
        let toggleBtn = item.querySelector(':scope > .submenu-toggle');
        if (!toggleBtn) {
            toggleBtn = document.createElement('button');
            toggleBtn.type = 'button';
            toggleBtn.className = 'submenu-toggle';
            toggleBtn.setAttribute('aria-expanded', 'false');

            // English comment: Accessible name includes the parent link text
            const parentText = (link.textContent || '').trim();
            toggleBtn.setAttribute('aria-label', 'Submenu openen voor ' + parentText);

            toggleBtn.innerHTML =
                '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="6 9 12 15 18 9"></polyline></svg>';

            // Insert after link
            link.insertAdjacentElement('afterend', toggleBtn);
        }

        // Toggle handler
        toggleBtn.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();

            const isExpanded = this.getAttribute('aria-expanded') === 'true';

            // Close other open submenus
            document.querySelectorAll('.mobile-menu .submenu-toggle').forEach(function(btn) {
                if (btn !== toggleBtn) {
                    btn.setAttribute('aria-expanded', 'false');
                    btn.classList.remove('is-open');
                    const otherSubmenu = btn.parentElement.querySelector(':scope > .sub-menu');
                    if (otherSubmenu) {
                        otherSubmenu.classList.remove('is-open');
                        otherSubmenu.setAttribute('aria-hidden', 'true');
                    }
                    // Update accessible name for others
                    const otherLink = btn.parentElement.querySelector(':scope > a');
                    if (otherLink) {
                        const txt = (otherLink.textContent || '').trim();
                        btn.setAttribute('aria-label', 'Submenu openen voor ' + txt);
                    }
                }
            });

            // Toggle current
            if (!isExpanded) {
                submenu.classList.add('is-open');
                submenu.setAttribute('aria-hidden', 'false');
                this.setAttribute('aria-expanded', 'true');
                this.classList.add('is-open');

                // English comment: Update the accessible name to "close"
                this.setAttribute('aria-label', 'Submenu sluiten voor ' + (link.textContent || '').trim());
            } else {
                submenu.classList.remove('is-open');
                submenu.setAttribute('aria-hidden', 'true');
                this.setAttribute('aria-expanded', 'false');
                this.classList.remove('is-open');
                this.setAttribute('aria-label', 'Submenu openen voor ' + (link.textContent || '').trim());
            }
        });
    });
})();